import 'antd/es/tabs/style/css';
import './index.less';
